<template>
  <form :action="action_url" method="POST" accept-charset="UTF-8">
    <input type="hidden" name="_token" :value="csrf_token">
    <section class="section--sidebar-user">
      <section class="section--content-sidebar section--content-sidebar-full-height">
        <div class="row mb-2">
          <div class="col-md-8 mb-2 mb-md-0">
            <div class="alert alert-warning mb-0 h-100 d-flex align-items-center">
              <i class="fa-solid fa-circle-info mr-2"></i>
              <span>
                {{ __('misc.massive_assign_permission_dsc') }}
              </span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="alert alert-primary mb-0 h-100 d-flex align-items-center justify-content-between">
              <span class="mr-3">
                {{ __('misc.massive_assign_recursive') }}
              </span>
              <div class="custom-control custom-switch mb-0">
                <input type="checkbox" class="custom-control-input" id="recursive-assign" name="recursive">
                <label class="custom-control-label" for="recursive-assign"></label>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="row">
            <div class="col-3">
              <label> {{ __('misc.filterBy') }}: {{ __('views.Modules.peopleGroups.title') }}</label>
              <select v-model="people_group_id" name="people_group" @change="filter($event)" class="form-control" >
                <option value="">---</option>
                <option v-for="row in people_groups" :value="row.id" v-bind:key="row.id">
                  {{ row.name }}
                </option>
              </select>
            </div>
            <div class="col-3">
              <label>{{ __('misc.filterBy') }}: {{ __('misc.user_type') }}</label>
              <select v-model="typology_id" name="typology" @change="filter($event)" class="form-control" >
                <option value="">---</option>
                <option v-for="row in people_typology" :value="row.id" v-bind:key="row.id">
                  {{ row.name }}
                </option>
              </select>
            </div>
            <div class="col-3">
              <label>{{ __('misc.person') }}</label>
              <select v-model="person_id" name="person" @change="insertPerson($event)" class="form-control">
                <option value="null">---</option>
                <option v-for="row in people_select" :value="row.id" v-bind:key="row.id">
                  {{ row.name }}
                </option>
              </select>
            </div>
            <div class="col-3 d-flex align-items-end justify-content-center">
              <a href="#" class="btn btn-small mr-2" @click="addAllTypology()">
                {{ __('misc.add_all') }}
              </a>
              <a href="#" class="btn btn-small" @click="destroyAllPeople()">
                {{ __('misc.remove_all') }}
              </a>
            </div>
          </div>
        </div>

        <p class="mb-2">
          <span class="text-voice-title">{{ __('misc.total_people') }}:</span> <span class="text-voice-value">{{ people_reader.length }}</span> /
          <span class="text-voice-title">{{ __('misc.selected_people') }}:</span> <span class="text-voice-value">{{ people_added.length }}</span>
        </p>

        <div class="massive-people-layout">
          <div class="massive-people-table-wrapper">
            <table class="table massive-people-table">
              <thead>
                <tr>
                  <th style="width: 40px;"></th>
                  <th>{{ __('misc.name') }}</th>
                  <th>{{ __('misc.relationship') }}</th>
                  <th>
                    <div class="d-flex align-items-center">
                      <span>{{ __('misc.read') }}</span>
                      <button type="button" class="ml-2 btn btn--mini btn--only-icon btn--transparent circle-button circle-button-edit" :title="`${__('misc.select_all')}`" @click="setCheckAllPeople(1, 'can_see')">
                        <i class="fa-duotone fa-regular fa-check-double" aria-hidden="true"></i>
                      </button>
                      <button type="button" class="ml-2 btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove" :title="`${__('misc.unselect_all')}`" @click="setCheckAllPeople(0, 'can_see')">
                        <i class="fa-duotone fa-regular fa-xmark" aria-hidden="true"></i>
                      </button>
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">
                      <span>{{ __('misc.feedback_mail') }}</span>
                      <button type="button" class="ml-2 btn btn--mini btn--only-icon btn--transparent circle-button circle-button-edit" :title="`${__('misc.select_all')}`" @click="setCheckAllPeople(1, 'flag_email_feedback')">
                        <i class="fa-duotone fa-regular fa-check-double" aria-hidden="true"></i>
                      </button>
                      <button type="button" class="ml-2 btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove" :title="`${__('misc.unselect_all')}`" @click="setCheckAllPeople(0, 'flag_email_feedback')">
                        <i class="fa-duotone fa-regular fa-xmark" aria-hidden="true"></i>
                      </button>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
            <tr v-for="row in people_added" v-bind:key="row.id">
                  <td>
                <a href="#" @click="deleteRow(row.id)"
                  ><i class="fa fa-trash"></i>
                    </a>
                    <input
                      type="hidden"
                      :value="row.id"
                      :name="'person[' + row.id + ']'"
                    />
                  </td>
                  <td>{{ row.name }}</td>
                  <td>{{ row.typology }}</td>
                  <td>
                    <input
                      type="checkbox"
                      value="1"
                      :name="'person[' + row.id + '][can_see]'"
                      v-model="row.can_see"
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      value="1"
                      :name="'person[' + row.id + '][flag_email_feedback]'"
                      v-model="row.flag_email_feedback"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="form-buttons clear mb-4 massive-people-footer">
            <button type="submit" class="btn btn--green">
              <i class="fa fa-save"></i>
              Salva
            </button>
          </div>
        </div>
      </section>
    </section>
  </form>
</template>

<script>
export default {
  mounted() {
    for (let i = 0; i < this.people_reader.length; i++){      
      this.people_reader[i].can_see = false;
      this.people_reader[i].flag_email_feedback = false;
    }
    this.action_url = "people-media/action/store-file-from-folder/" + this.folder_id;
  },
  data() {
    return {
      action_url: "",
      people_group_id: null,
      typology_id: null,
      person_id: null,
      people_select: [],
      people_added: [],
    };
  },
  props: {
    people_reader:{
      type: Array,
      required: true,
    },
    people_typology: {
      type: Array,
      required: true,
    },
    people_groups: {
      type: Array,
      required: true
    },
    folder_id: {
      type: Number,
      required: true,
    },
    csrf_token:{
      type: String,
      required: true,
    }
  },
  methods: {
    destroyAllPeople() {

      if (this.people_select && this.people_select.length > 0){        
          let result = this.people_added;
          for(let a = 0; a < this.people_select.length; a++){            
            for(let i = 0; i < this.people_added.length; i++){
              if(this.people_select[a].id == this.people_added[i].id){
                result.splice(i, 1);
              }
            }            
          }

          this.people_added = result;
      }
    },
    addAllTypology() {

      if (this.people_select && this.people_select.length > 0){
        for(let a = 0; a < this.people_select.length; a++) {
           let exists = false;
            for(let i = 0; i < this.people_added.length; i++){
              if(this.people_select[a].id == this.people_added[i].id){
                exists = true;
              }
            }
            if (!exists){
              this.people_added.push(this.people_select[a]);
            }
        }
      }
    },
    getPeople(event) {
      if (event.target.value == "null"){
        this.people_select = [];
        return;
      }
      this.typology_id = event.target.value;      
    },
    deleteRow(row_id) {
      for(let r = 0; r < this.people_added.length; r++){
        if (this.people_added[r].id == row_id){
          this.people_added.splice(r, 1);
        }
      }
    },
    filter(event) {      
      this.people_select = this.people_reader;

      if (this.typology_id != null && this.typology_id != "") {
        this.people_select = this.people_select.filter(obj => {
          return obj.typology_id === parseInt(this.typology_id);
        });
      }

      if (this.people_group_id != null && this.people_group_id != "") {
        let peopleGroup = this.people_groups.filter(pg => {return pg.id == this.people_group_id});
        if (peopleGroup.length > 0){
          this.people_select = this.people_select.filter(p => {
            return peopleGroup[0].memberEmployees.find(pe => {
              return pe.id === parseInt(p.id);
            }) !== undefined;
          });
        }
      }
    },
    insertPerson(event) {

      let person_id = event.target.value;      
      let person = null;

      for(let r = 0; r < this.people_reader.length; r++){
        if (this.people_reader[r].id == person_id){
          person = this.people_reader[r];
        }
      }

      if (person == null){
        return;
      }
              
      let result = this.people_added;          
      let exists = false;
      for(let i = 0; i < this.people_added.length; i++){
        if(person_id == this.people_added[i].id){
          exists = true;
        }
      }
      if (!exists){
        result.push(person);
      }
    },    
    setCheckAllPeople(set, field) {
      for(let r = 0; r < this.people_added.length; r++) {
        if (field == 'can_see') {
          this.people_added[r].can_see = set;
        }
        if (field == 'flag_email_feedback') {
          this.people_added[r].flag_email_feedback = set;
        }
      }
    },
  },
};
</script>
<style>
.custom-actions button.ui.button {
  padding: 8px 8px;
}
.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}


.section--sidebar-user {
  display: flex;
  flex-direction: column;
  height: 100%; /* se è in un popup, assicurati che il popup abbia altezza definita */
}

.section--content-sidebar-full-height {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

/* Layout verticale: tabella + footer */
.massive-people-layout {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%; /* necessario per far funzionare flex */
}

/* Scroll solo sulla tabella */
.massive-people-table-wrapper {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  position: relative;
  border: none;
  border-radius: 4px;
}

/* Altezza massima relativa al viewport, così il footer rimane sempre visibile */
.massive-people-table-wrapper {
  max-height:45vh ;
}

/* Tabella e celle */
.massive-people-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.massive-people-table th,
.massive-people-table td {
  padding: 0.4rem 0.5rem;
  vertical-align: middle;
}

/* Header sticky */
.massive-people-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #fff;
  border-bottom: 1px solid #DFE6F6;
}

/* Footer fisso in fondo */
.massive-people-footer {
  flex: 0 0 auto;
  padding-top: 0.75rem;
  background: #fff;
}


</style>